const _excluded = ["bootstrapModal", "children", "className", "style", "show", "next", "previous", "navigationEnabled", "disabledNavigationArrows", "disabledNavigationPrevArrow", "disabledNavigationNextArrow", "onClose"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import theme, { stylePropType } from '@adsk/alloy-react-theme';
import Modal from '../Modal';
/**
 * This component allows for displaying a content in a modal dialog
 * while providing next/previous navigation actions.
 */
const ModalPreviewNavigation = _ref => {
  let {
      bootstrapModal = {},
      children,
      className = bootstrapModal.bsClass,
      style,
      show = bootstrapModal.show,
      next,
      previous,
      navigationEnabled = false,
      disabledNavigationArrows,
      disabledNavigationPrevArrow,
      disabledNavigationNextArrow,
      onClose = bootstrapModal.onClose
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Modal, _extends({
    className: className,
    style: style,
    open: show,
    onClose: onClose
  }, props), /*#__PURE__*/React.createElement(Modal.Close, {
    onClick: onClose,
    style: {
      position: 'absolute',
      top: '0',
      right: '-40px',
      margin: 0,
      color: theme.tokens.colors.icon.inverse.value
    }
  }), navigationEnabled && /*#__PURE__*/React.createElement(Modal.PrevArrow, {
    disabled: disabledNavigationArrows || disabledNavigationPrevArrow,
    onClick: previous
  }), navigationEnabled && /*#__PURE__*/React.createElement(Modal.NextArrow, {
    disabled: disabledNavigationArrows || disabledNavigationNextArrow,
    onClick: next
  }), children);
};
ModalPreviewNavigation.CLOSE_BUTTON_STYLE = {
  DEFAULT: '',
  NO_BUTTON: 'NO_BUTTON',
  INNER_CLOSE_BUTTON: 'INNER_CLOSE_BUTTON'
};
ModalPreviewNavigation.propTypes = {
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
  /** overwrite default props */
  bootstrapModal: PropTypes.shape({
    /**
     * A callback function for modal close event
     */
    onClose: PropTypes.func,
    /**
     * Whether to show the modal or not
     */
    show: PropTypes.bool,
    /**
     * A custom className for the modal component. This class will be passed to Modal component.
     */
    bsClass: PropTypes.string
  }).isRequired,
  /**
   * A callback that's called when hiding the modal. (same as `bootstrapModal.onClose` prop)
   */
  onClose: PropTypes.func,
  /**
   * Whether or not to show the modal. (same as `bootstrapModal.show` prop)
   */
  show: PropTypes.bool,
  /**
   * A callback function for previous button click event
   */
  previous: PropTypes.func,
  /**
   * A callback function for next button click event
   */
  next: PropTypes.func,
  /**
   * Determines whether navigation is enabled. If false is passed, navigation is disabled and arrows are not visible. Defaults to false.
   */
  navigationEnabled: PropTypes.bool,
  /**
   * Disables navigation next arrow (still shows them, but disabled). Disables navigation
   */
  disabledNavigationNextArrow: PropTypes.bool,
  /**
   * Disables navigation back arrow (still shows them, but disabled). Disables navigation
   */
  disabledNavigationPrevArrow: PropTypes.bool,
  /**
   * Disables navigation next arrow (still shows them, but disabled). Disables navigation
   */
  disabledNavigationArrows: PropTypes.bool,
  /**
   * Modal content
   */
  children: PropTypes.node
};
export default ModalPreviewNavigation;
//# sourceMappingURL=ModalPreviewNavigation.js.map